export default __webpack_public_path__ + "static/modal-do-dark-9d3fa4bd2493247b0847988c778bfc77.png";